
  import React from "react"
  import Component from "/Users/adam/Documents/GitHub/altola-blog/src/layouts/index.jsx"
  import data from "/Users/adam/Documents/GitHub/altola-blog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js